import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import { blogPost } from '../../Models/Session';


@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css'],standalone:false
})
export class LandingPageComponent implements OnInit {
  public showSplash: boolean = true;

  sessionDataArray: blogPost[] = [];
  loading: boolean = false;
  selectedLanguage: string = 'en';

  constructor() {

  }



  ngOnInit(): void {

  }
}
